import {gql, useQuery} from "@apollo/client";
import {DSP_FIELDS, DspType} from "../types/DspType";
import { useEffect, useState } from "react";

export const GET_ALL_DSPS = gql`
  query GetAllDsps {
    allDsps: getAllDsps {
      ...DspFields
    }
  }
  ${DSP_FIELDS}
`;

interface GetAllDspsResponse {
    allDsps: DspType[];
}


export const useAllDsps = () => {
    const [allDsps, setAllDsps] = useState<DspType[]>([]);
    const {data, loading, error, refetch} = useQuery<GetAllDspsResponse>(GET_ALL_DSPS);
    useEffect(() => {
        if (data) {
           setAllDsps(data.allDsps.map(dsp => ({...dsp, warehouseIds: dsp.warehouses.map(warehouse => Number(warehouse.id))})));
      }
    }, [data]);

  return {
    allDsps,
    loading,
    refetch,
    error
  };
};
